import { useMemo } from 'react'

import { QueryOptions, useCubeReportPageFiltersContext } from 'cube'
import { MEETINGS_DIMENSIONS } from 'cube/constants'
import { MeetingCountQuery } from 'cube/queries'
import moment from 'moment'

import {
  CubeQueryBuilder,
  resultSetAsTableData,
  useCubeQuery,
} from '@driftt/dds.reports'

import useTimePeriod from 'hooks/useTimePeriod'

export const useSiteConciergeMeetingsBooked = (options?: QueryOptions) => {
  const timePeriod = useTimePeriod()
  const { isPreviousTimePeriod = false } = { ...options }
  const { pageFilters = [] } = useCubeReportPageFiltersContext()

  const dateRange: [string, string] = [
    moment(
      isPreviousTimePeriod ? timePeriod.prevStart : timePeriod.startDate
    ).format('YYYY-MM-DD'),
    moment(
      isPreviousTimePeriod ? timePeriod.prevEnd : timePeriod.endDate
    ).format('YYYY-MM-DD'),
  ]

  const cubeQuery = new CubeQueryBuilder({
    query: MeetingCountQuery,
  })
    .withName('SiteConciergeMeetingsBooked')
    .withFilters([
      {
        member: MEETINGS_DIMENSIONS.MEETING_SOURCE,
        operator: 'equals',
        values: ['SITE_CONCIERGE'],
      },
      ...pageFilters,
    ])
    .withTimeDimensions([
      {
        dimension: MEETINGS_DIMENSIONS.SCHEDULED_AT,
        dateRange: dateRange,
      },
    ])
    .build()

  const { data, isLoading, isError } = useCubeQuery({
    query: cubeQuery,
  })

  const cardData = useMemo(() => {
    return resultSetAsTableData(data)
  }, [data])

  const meetingsBooked = cardData?.map(({ DriftChatSchedulingEvents }) => {
    return Number(DriftChatSchedulingEvents.count) || 0
  })[0]

  return { meetingsBooked, isLoading, isError }
}

export default useSiteConciergeMeetingsBooked
